export default {
  tabs: {
    keyLights: '按键灯',
    sideLights: '侧灯',
    statusIsland: '状态岛指示灯',
    stripLight: '灯带',
    nameplateLight: '铭牌灯',
    indicatorLight: 'RGB 指示灯',
    audioRhythm: '音乐律动',
  },
  select: {
    selectAll: '按键全选',
    invertSelection: '按键反选',
  },
  current: '当前',
  vibrant: '炫彩',
  preset: '预设',
  lightingSetting: '灯光设置',
  switchTooltip: {
    turnOff: '关闭灯光',
    turnOn: '开启灯光',
  },
  audioShareTooltip: '点击右侧按钮共享音频(需共享系统声音)',
  referenceOnly: '示意非精确显示，仅供参考',
  colorTitle: '颜色',
  audioRhythmStatus: {
    idle: '共享音频',
    requesting: '请求中',
    stop: '停止采集',
    systemAudio: '系统音频',
    microphone: '麦克风',
    error: '音频错误',
    noAudioTrack: '未获取到音频，请在分享窗口勾选「分享系统音频」或「标签页音频」',
    shareEnded: '音频分享已结束',
  },
  audioRhythmSettings: {
    title: '设置',
    lowSensitivity: '低频灵敏度',
    midSensitivity: '中频灵敏度',
    highSensitivity: '高频灵敏度',
    brightness: '整体亮度',
    trailSmoothing: '拖尾平滑',
  },
  audioRhythmColor: {
    neonCyan: '霓虹青',
    neonBlue: '霓虹蓝',
    electricArc: '电弧',
    neonPurple: '霓虹紫',
    neonPink: '霓虹粉',
    flame: '烈焰',
    neonGreen: '霓虹绿',
    neonYellow: '霓虹黄',
    neonOrange: '霓虹橙',
    rainbow: '彩虹',
  },
  customLighting: {
    title: '自定义灯光',
    description: '中文名称最长不超过4个字符；英文数字不超12个字符',
    singleColorRadio: '单色静态灯效',
    twoToneGradientRadio: '双色渐变灯效',
  },
  deleteCustom: {
    title: '删除自定义灯效',
    description: '确认删除此灯效文件，删除后需重新添加不可恢复',
  },
  lightMode: {
    lightingTitle: '灯光模式',
    chargingTitle: '充电状态',
    ambientLightingTitle: '显示氛围灯',
    ambientLightingExcerpt: '优先显示用户自定义灯效，鼠标充电时不显示任何灯效',
    chargingLightingTitle: '显示充电灯',
    chargingLightingExcerpt: '鼠标充电时，氛围灯同时进入充电灯模式',
    syncTitle: '同步灯效',
  },
  brightness: '亮度',
  lightingSpeed: '灯光速度',
  lightingDirection: '灯光方向',
  verticalGradient: '上下渐变',
  horizontalGradient: '左右渐变',
  forward: '正向',
  reverse: '反向',
  directionTips: '正向 / 反向',
  directionLeftToRight: '从左向右',
  directionRightToLeft: '从右向左',
  directionTopToBottom: '从上向下',
  directionBottomToTop: '从下向上',
  directionCenterToOuter: '从内至外',
  directionOuterToCenter: '从外至内',
  directionCounterClockwise: '逆时针',
  directionClockwise: '顺时针',
  effect: {
    wave_flow: '波浪流动',
    colorful_raindrop_falling: '落雨缤纷',
    breathing: '呼吸模式',
    stars_twinkle: '星光闪烁',
    ripple: '泛起涟漪',
    shadow_chasing: '如影随行',
    swiftly: '流星赶月',
    sudden_turn: '峰回路转',
    great_winged: '大鹏展翅',
    seeking_plum_blossoms: '踏雪寻梅',
    snap: '一触即发',
    click_diffusion: '点击扩散',
    twinkling_stars: '繁星点点',
    rgb_constant: 'RGB常亮',
    blue_sky_white_clouds: '蓝天白云',
    row_gradient: '左右渐变',
    col_gradient: '上下渐变',
    moba: 'MOBA',
    fps: 'FPS',
    car: 'CAR',
    rgb_flow: 'RGB流光',
    static: '单色常亮',
    static_breathing: '单色呼吸',
    /* P5/P6 Telink_Base 灯效 */
    spectrum_cycle: '光谱循环',
    magic_color: '幻彩模式',
    /* ESPR/VPR VT_nrf54L_Base 灯效 */
    rgb_colorful: 'RGB炫彩',
    color_breathing: '彩色呼吸',
    battery_indicator: '电量指示',
    battery_indicator_tip: '选中时，优先显示鼠标当前电量',
    indicator: '充电状态时',
    indicatorTip: '自定义键盘充电时指示灯的充电效果',
    ambient: '氛围灯状态时',
    ambientTip: '自定义键盘未充电时指示灯的氛围效果',
    horse_race_lamp: '跑马',
    sinusoid: '弦曲曲线',
    spiral: '螺旋',
    fill: '充满',
    stacks: '堆',
    swap: '交换',
    /* GCOME_AP 协议灯效 0-22 */
    game_mode: '灯光自定义',
    spectrum: '光谱循环',
    gradient: '阶梯渐变',
    flower: '百花争艳',
    wave: '波浪',
    wave_upr: '上下波浪',
    fountain: '喷泉',
    glisten: '银河波光',
    vortex: '旋转风火轮',
    tide: '潮汐',
    swing: '摆动海浪',
    ripple_on: '常亮涟漪',
    single: '单点亮光',
    cell: '宫格',
    knock: '钢琴演奏',
    across: '流光',
    rain: '落雨',
    starry: '星光',
    firework: '烟花',
    wave_bar: '波带',
    off: '关灯',
    /* GCOME_AP 音乐律动（软件灯效） */
    spectrum_bar: '频谱柱',
    central_pulse: '中央脉冲',
    peak_meter: '峰值仪',
    scan_line: '扫描线',
    audio_wave: '波浪',
    flame: '火焰',
    beat_breathe: '节拍呼吸',
  },
}
